import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import Title from './header-nav-title.js'
import MenuMainDesktop from './header-menu-main-desktop.js'
import MenuMainMobile from './header-menu-main-mobile.js'
import Toggle from './header-menu-main-mobile-toggle.js'
import Social from './header-nav-social.js'

const UnstyledNav = ({
  className
}) => {
  const props = {
    className 
  }

  return (
    <div {...props}>
      <Title/>
      <Items>
        <MenuMainDesktop/>
        <MenuMainMobile/>
        <Social/>
        <Toggle/>
      </Items>
    </div>
  )
}

const Nav = styled(UnstyledNav)`
  padding: 0 ${theme.padding.horizontal};
  height: ${theme.padding.mediumLarge};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Items = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export default Nav